import { IRequesterInfo } from '../../../../../base/models'
import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IPO } from '../models'

export class DeletePODocumentApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'MyReports/DeletePODocument',
      requesterInfo,
    })
  }
  public async deleteDocument(req: string): Promise<IPO[]> {
    return await this.postAsync<IPO[]>(JSON.stringify(req))
  }
}
